import Handler from './handler';
import type { GetGoodsListConditionRange, GoodsItem } from '../types';

class RangeHandler extends Handler {
  handle(goodsList: GoodsItem[]): GoodsItem[] {
    const condition = this.condition as GetGoodsListConditionRange;
    return goodsList?.filter((item) => {
      const value = item[condition.key];
      let result = true;
      if (condition.needMin) {
        result = result
          && (condition.minEqual ? (value >= condition.min) : (value > condition.min));
      }
      if (condition.needMax) {
        result = result
          && (condition.maxEqual ? (value <= condition.max) : (value < condition.max));
      }
      return result;
    });
  }
}

export default RangeHandler;
